function outerHeight(el, includeMargin) {
  if (!el) {
    return 0;
  }
  let height = el.offsetHeight;
  if (includeMargin) {
    const style = window.getComputedStyle(el);
    height += (parseFloat(style.marginTop) || 0) + (parseFloat(style.marginBottom) || 0);
  }
  return height;
}

function offsetTop(el) {
  const rect = el.getBoundingClientRect();
  return rect.top + (window.pageYOffset || document.documentElement.scrollTop);
}

export function fixx(element, options) {
  if (!element) {
    return function destroy() {};
  }

  const defaults = {
    offset: 0,
    offsetCallback: false,
    responsiveBreakpoints: {
      sm: 768,
      md: 992,
      lg: 1200,
    },
    fixedBreakpoints: ['xs', 'sm', 'md', 'lg'],
    startElement: document.body,
    startAt: 'top',
    startThreshold: 0,
    startThresholdCallback: false,
    endElement: null,
    endAt: 'bottom',
    endThreshold: 0,
    placeholder: true,
    placeholderPrepend: true,
    placeholderClass: '',
    stateFixedClass: 'fixed',
    stateStaticClass: 'static',
    stateFreezeClass: 'freeze',
    leftPositioning: true,
  };

  const optionsObj = { ...defaults, ...(options || {}) };
  const startElement = optionsObj.startElement || document.body;
  const endElement = optionsObj.endElement;

  let placeholder = optionsObj.placeholderElement || null;
  let createdPlaceholder = false;
  if (!placeholder && optionsObj.placeholder) {
    placeholder = document.createElement('div');
    placeholder.className = `fixx-placeholder ${optionsObj.placeholderClass || ''}`.trim();
    placeholder.style.height = '1px';
    placeholder.style.marginTop = '-1px';
    createdPlaceholder = true;
    if (optionsObj.placeholderPrepend) {
      element.parentNode?.insertBefore(placeholder, element);
    } else {
      element.parentNode?.insertBefore(placeholder, element.nextSibling);
    }
  }

  const viewportWidth = function () {
    const width = window.innerWidth;
    if (optionsObj.responsiveBreakpoints) {
      if (width < optionsObj.responsiveBreakpoints.sm) {
        return 'xs';
      }
      if (width >= optionsObj.responsiveBreakpoints.lg) {
        return 'lg';
      }
      if (width >= optionsObj.responsiveBreakpoints.md) {
        return 'md';
      }
      if (width >= optionsObj.responsiveBreakpoints.sm) {
        return 'sm';
      }
    }
    return 'lg';
  };

  const fix = function () {
    if (!placeholder) {
      return;
    }
    const pos = placeholder.getBoundingClientRect();
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const vw = viewportWidth();
    const isAcceptedBreakpoint = optionsObj.fixedBreakpoints.indexOf(vw) > -1;
    const elementHeight = outerHeight(element, true);

    if (typeof optionsObj.offsetCallback === 'function') {
      optionsObj.offset = optionsObj.offsetCallback();
    }
    if (typeof optionsObj.startThresholdCallback === 'function') {
      optionsObj.startThreshold = optionsObj.startThresholdCallback();
    }

    const startPoint = function () {
      let startPointOffset = 0;
      if (startElement) {
        startPointOffset = offsetTop(startElement);
        if (optionsObj.startAt === 'bottom') {
          startPointOffset += outerHeight(startElement) - optionsObj.offset;
        }
      } else {
        startPointOffset = offsetTop(placeholder) - optionsObj.offset;
      }
      return startPointOffset + optionsObj.startThreshold;
    };

    const endPoint = function () {
      let endPointOffset = 9999999999;
      if (endElement) {
        endPointOffset = offsetTop(endElement);
        if (optionsObj.endAt === 'bottom') {
          endPointOffset += outerHeight(endElement);
        }
        endPointOffset -= (outerHeight(element, true) + (optionsObj.offset * 2));
      }
      return endPointOffset + optionsObj.endThreshold;
    };

    if (isAcceptedBreakpoint && scrollTop > startPoint()) {
      element.classList.remove(optionsObj.stateStaticClass);
      element.classList.add(optionsObj.stateFixedClass);

      if (scrollTop >= endPoint()) {
        element.classList.add(optionsObj.stateFreezeClass);
      } else {
        element.classList.remove(optionsObj.stateFreezeClass);
      }
    } else {
      element.classList.add(optionsObj.stateStaticClass);
      element.classList.remove(optionsObj.stateFixedClass);
      element.classList.remove(optionsObj.stateFreezeClass);
    }

    if (element.classList.contains(optionsObj.stateFixedClass)) {
      if (optionsObj.placeholder && placeholder) {
        placeholder.style.height = `${elementHeight}px`;
        placeholder.style.marginTop = '';
      }

      let topPos;
      if (element.classList.contains(optionsObj.stateFreezeClass)) {
        topPos = endPoint() - (scrollTop - optionsObj.offset);
      } else {
        topPos = optionsObj.offset;
      }

      element.style.width = `${placeholder.getBoundingClientRect().width}px`;
      element.style.top = `${topPos}px`;

      // Preserve the original plugin's caller-only leftPositioning check.
      if (options && options.leftPositioning) {
        element.style.left = `${pos.left}px`;
      }
    } else {
      element.removeAttribute('style');
      if (optionsObj.placeholder && placeholder && createdPlaceholder) {
        placeholder.style.height = '1px';
        placeholder.style.marginTop = '-1px';
      } else if (optionsObj.placeholder && placeholder) {
        placeholder.removeAttribute('style');
      }
    }
  };

  window.addEventListener('resize', fix);
  window.addEventListener('scroll', fix, { passive: true });
  fix();

  return function destroy() {
    window.removeEventListener('resize', fix);
    window.removeEventListener('scroll', fix);
    element.classList.remove(
      optionsObj.stateFixedClass,
      optionsObj.stateStaticClass,
      optionsObj.stateFreezeClass,
    );
    element.removeAttribute('style');
    if (createdPlaceholder && placeholder?.parentNode) {
      placeholder.parentNode.removeChild(placeholder);
    }
  };
}
